const TAB_ROOTS = '.product-infos, .product-infos-table, .product-infos-table-mobile';

const panelFor = (root, tab) => {
    const id = tab.getAttribute('aria-controls');

    if (!id || typeof CSS === 'undefined' || typeof CSS.escape !== 'function') {
        return id ? root.querySelector(`[id="${id}"]`) : null;
    }

    return root.querySelector(`#${CSS.escape(id)}`);
};

const selectTab = (tabs, tab) => {
    tabs.forEach((item) => {
        const selected = item === tab;
        const panel = item.panel;

        item.classList.toggle('active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;

        if (!panel) {
            return;
        }

        panel.classList.toggle('active', selected);
        panel.hidden = !selected;
    });
};

const setupTabGroup = (root) => {
    if (root.dataset.tabsReady === 'true') {
        return;
    }

    const tablist = root.querySelector('[role="tablist"]');

    if (!tablist) {
        return;
    }

    const tabs = [...tablist.querySelectorAll('[role="tab"]')].map((tab) => {
        tab.panel = panelFor(root, tab);

        return tab;
    });

    if (!tabs.length) {
        return;
    }

    root.dataset.tabsReady = 'true';

    const current = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    selectTab(tabs, current);

    tablist.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');

        if (!tab || !tabs.includes(tab)) {
            return;
        }

        selectTab(tabs, tab);
    });

    tablist.addEventListener('keydown', (event) => {
        const currentTab = event.target.closest('[role="tab"]');
        const index = tabs.indexOf(currentTab);

        if (index === -1) {
            return;
        }

        const moveTo = {
            ArrowRight: tabs[(index + 1) % tabs.length],
            ArrowLeft: tabs[(index - 1 + tabs.length) % tabs.length],
            Home: tabs[0],
            End: tabs[tabs.length - 1],
        }[event.key];

        if (!moveTo) {
            return;
        }

        event.preventDefault();
        selectTab(tabs, moveTo);
        moveTo.focus();
    });
};

const initProductInfos = () => {
    document.querySelectorAll(TAB_ROOTS).forEach(setupTabGroup);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductInfos);
} else {
    initProductInfos();
}
